import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Footer from "./components/Footer";
import Home from "./components/Home";
import Form from "./components/Form";
import Privacy from "./components/Privacy";
import Thanks from "./components/Thanks";

function App() {
  return (
    <BrowserRouter>
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/registration" element={<Form />} />
      <Route path='privacy-policy' element={<Privacy />} />
      <Route path='thank-you' element={<Thanks />} />
    </Routes>
    <Footer />
  </BrowserRouter>
);
}

export default App;
